import { BoldTextButton } from "thrive-components";
import { getAcknowledgementPostTitle } from "../notificationTitles.service";


export interface IAcknowledgementPostTitle {
    content: {
        id?: number;
        title: string;
        link: string;
    }
    user: string;
    isPopOut?: boolean
}

const AcknowledgementPostTitle = ({content, user, isPopOut}: IAcknowledgementPostTitle ) => {
    const {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle} = getAcknowledgementPostTitle({content, user, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}

            <BoldTextButton
                ariaLabel={contentLinkAriaLabel}
                link={contentLink}
                text={contentLinkTitle}
            />
        </span>
    );
};
export default AcknowledgementPostTitle;
